(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/utils/utils.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/utils/utils.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const _svs$ticketsOrderHome = svs.ticketsOrderHome.utils.constants,
  MAXIMUM_TOTAL_QUANTITY_WEIGHT = _svs$ticketsOrderHome.MAXIMUM_TOTAL_QUANTITY_WEIGHT,
  productCodeMap = _svs$ticketsOrderHome.productCodeMap,
  VERIFIED = _svs$ticketsOrderHome.ContactInfoStatus.VERIFIED;
const logger = svs.core.log.getLogger('tickets-order-home');
const characterValidator = value => {
  const characterRegex = /^[a-zA-ZåäöÅÄÖáéíóúýæþðåäöÁÉÍÓÚÝÆÞÐÅÄÖ0-9\s-*]*$/;
  return characterRegex.test(value);
};
const getHasAfterPayParam = () => {
  const afterPay = svs.utils.paramHandler.get({
    key: 'afterpay'
  }).value;
  svs.utils.paramHandler.remove({
    key: 'afterpay'
  });
  return Boolean(afterPay);
};
const emojiValidator = value => {
  const emojiRanges = ['\\u{1F600}-\\u{1F64F}', '\\u{1F300}-\\u{1F5FF}', '\\u{1F680}-\\u{1F6FF}', '\\u{1F700}-\\u{1F77F}', '\\u{1F900}-\\u{1F9FF}', '\\u{2600}-\\u{26FF}', '\\u{2700}-\\u{27BF}', '\\u{FE00}-\\u{FE0F}', '\\u{1F1E6}-\\u{1F1FF}', '\\u{1F18E}-\\u{1F1AD}'];
  const emojiRegex = new RegExp("[".concat(emojiRanges.join(''), "]"), 'gu');
  return emojiRegex.test(value);
};
const validators = value => {
  const _svs$ticketsOrderHome2 = svs.ticketsOrderHome.utils.constants.orderHomeMessage,
    INVALID_EMOJI_INPUT_ERROR = _svs$ticketsOrderHome2.INVALID_EMOJI_INPUT_ERROR,
    MAX_GREETING_LENGTH_MESSAGE = _svs$ticketsOrderHome2.MAX_GREETING_LENGTH_MESSAGE,
    MAX_GREETING_LENGTH = _svs$ticketsOrderHome2.MAX_GREETING_LENGTH,
    MAX_LINE_BREAKS = _svs$ticketsOrderHome2.MAX_LINE_BREAKS,
    MAX_LINE_ERROR_MESSAGE = _svs$ticketsOrderHome2.MAX_LINE_ERROR_MESSAGE;
  const lineBreaks = (value.match(/\n/g) || []).length;
  if (lineBreaks > MAX_LINE_BREAKS) {
    return {
      isValid: false,
      errorMessage: MAX_LINE_ERROR_MESSAGE
    };
  }
  if (emojiValidator(value)) {
    return {
      isValid: false,
      errorMessage: INVALID_EMOJI_INPUT_ERROR
    };
  }
  if (value.length > MAX_GREETING_LENGTH) {
    return {
      isValid: false,
      errorMessage: MAX_GREETING_LENGTH_MESSAGE.replace('{CURRENT_LENGTH}', value.length)
    };
  }
  return {
    isValid: true,
    errorMessage: ''
  };
};

const toTitleCase = string => {
  'use strict';

  const smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|v.?|vs.?|via)$/i;
  const alphanumericPattern = /([A-Za-z0-9\u00C0-\u00FF])/;
  const wordSeparators = /([ :–—-])/;
  return string === null || string === void 0 ? void 0 : string.split(wordSeparators).map((current, index, array) => {
    if (
    current.search(smallWords) > -1 && 
    index !== 0 && index !== array.length - 1 && 
    array[index - 3] !== ':' && array[index + 1] !== ':' && (
    array[index + 1] !== '-' || array[index - 1] === '-' && array[index + 1] === '-')) {
      return current.toLowerCase();
    }

    if (current.substr(1).search(/[A-Z]|\../) > -1) {
      return current;
    }

    if (array[index + 1] === ':' && array[index + 2] !== '') {
      return current;
    }

    return current.replace(alphanumericPattern, match => match.toUpperCase());
  }).join('');
};
const calculateTotalQuantityWeight = tickets => {
  const totalQuantityWeight = tickets.reduce((acc, ticket) => {
    var _productCodeMap$ticke;
    return acc + ticket.count * (((_productCodeMap$ticke = productCodeMap[ticket.id]) === null || _productCodeMap$ticke === void 0 ? void 0 : _productCodeMap$ticke.quantityWeight) || 1);
  }, 0);
  return totalQuantityWeight;
};
const appendTicketThemeToOrderItems = function (orderItems) {
  let ticketsConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : svs.ticketsOrderHome.data.config.orderHome.tickets;
  return orderItems.map(orderItem => {
    var _ticket$themeName;
    const ticket = ticketsConfig.find(ticket => parseInt(ticket.id, 10) === orderItem.productCode);
    return _objectSpread(_objectSpread({}, orderItem), {}, {
      themeName: (_ticket$themeName = ticket === null || ticket === void 0 ? void 0 : ticket.themeName) !== null && _ticket$themeName !== void 0 ? _ticket$themeName : ''
    });
  });
};
const areTicketsOverweight = tickets => {
  const totalQuantityWeight = calculateTotalQuantityWeight(tickets);
  return totalQuantityWeight > MAXIMUM_TOTAL_QUANTITY_WEIGHT;
};
const isMaximumQuantityWeightReached = tickets => {
  const totalQuantityWeight = calculateTotalQuantityWeight(tickets);
  return totalQuantityWeight >= MAXIMUM_TOTAL_QUANTITY_WEIGHT;
};
const isMaximumQuantityWeightReachedForTicket = (ticket, tickets) => {
  var _productCodeMap$ticke2;
  const totalQuantityWeight = calculateTotalQuantityWeight(tickets);
  return totalQuantityWeight + ((_productCodeMap$ticke2 = productCodeMap[ticket.id]) === null || _productCodeMap$ticke2 === void 0 ? void 0 : _productCodeMap$ticke2.quantityWeight) > MAXIMUM_TOTAL_QUANTITY_WEIGHT;
};
const showErrorMessage = (error, onConfirm) => {
  const fallbackTitle = 'Köpet kan inte genomföras';
  const fallbackMessage = "Kontakta <a href=\"".concat(svs.core.urlMapping.get('customerServiceContact'), "\">Kundservice</a>. Telefon 0770-11 11 11.");
  const response = error ? {
    error
  } : {
    error: {
      code: 0
    }
  };
  svs.tur.apierrors.showErrorMessage({
    response,
    fallbackTitle,
    fallbackMessage,
    onConfirm
  });
};
const formatCustomerPreferenceAddressInfo = function () {
  let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const formattedCustomerInfo = {};
  const _data$name = data.name,
    name = _data$name === void 0 ? '' : _data$name,
    _data$surname = data.surname,
    surname = _data$surname === void 0 ? '' : _data$surname,
    _data$address = data.address,
    address = _data$address === void 0 ? '' : _data$address,
    _data$postcode = data.postcode,
    postcode = _data$postcode === void 0 ? '' : _data$postcode,
    _data$location = data.location,
    location = _data$location === void 0 ? '' : _data$location,
    _data$email = data.email,
    email = _data$email === void 0 ? '' : _data$email;
  formattedCustomerInfo.fullName = name && surname ? toTitleCase("".concat(name, " ").concat(surname).toLowerCase()) : '';
  formattedCustomerInfo.addressRow1 = address ? toTitleCase(address === null || address === void 0 ? void 0 : address.toLowerCase()) : '';
  formattedCustomerInfo.addressRow2 = postcode && location ? toTitleCase("".concat(postcode, " ").concat(location).toLowerCase()) : '';
  formattedCustomerInfo.email = (email === null || email === void 0 ? void 0 : email.toLowerCase()) || '';
  formattedCustomerInfo.emailVerified = data.emailStatus === VERIFIED;
  return formattedCustomerInfo;
};
const isCustomerPreferenceAddressInfoMissing = function () {
  let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const address = data.address,
    postcode = data.postcode,
    location = data.location;
  return !address || !postcode || !location;
};

const getProductNameAndPrice = function () {
  let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? '' : _ref$name,
    _ref$price = _ref.price,
    price = _ref$price === void 0 ? '' : _ref$price;
  const productNameAndPrice = RegExp(/[0-9]{2,3}\b\skr\b/g).test(name.toLowerCase()) ? name : "".concat(name, " ").concat(price, " kr");
  return productNameAndPrice;
};
const getAccountBalanceAsync = () => new Promise(resolve => {
  svs.components.account_balance.get(true, balance => {
    resolve(balance);
  });
});
const getLatestAccountBalance = _ref2 => {
  let next = _ref2.next;
  getAccountBalanceAsync().then(balance => next({
    latestAccountBalance: svs.utils.format.CurrencyFromJupiterString(balance)
  })).catch(() => next({
    latestAccountBalance: undefined
  }));
};
const getAccountBalanceParams = _ref3 => {
  let isPayAfterDepositEnabled = _ref3.isPayAfterDepositEnabled,
    price = _ref3.price;
  const product = 'triss';
  if (!isPayAfterDepositEnabled) return {
    price
  };
  return {
    price,
    product,
    isAutoPayAfterDeposit: true
  };
};
const getConfirmPaymentOptions = _ref4 => {
  let price = _ref4.price,
    accountBalance = _ref4.accountBalance;
  return {
    price,
    accountBalance,
    title: "Vill du betala Triss f\xF6r ".concat(price, " kr?"),
    messages: ['Köpet går inte att annullera.']
  };
};
setGlobal('svs.ticketsOrderHome.utils', {
  logger,
  characterValidator,
  validators,
  toTitleCase,
  calculateTotalQuantityWeight,
  areTicketsOverweight,
  isMaximumQuantityWeightReached,
  isMaximumQuantityWeightReachedForTicket,
  showErrorMessage,
  formatCustomerPreferenceAddressInfo,
  isCustomerPreferenceAddressInfoMissing,
  getProductNameAndPrice,
  appendTicketThemeToOrderItems,
  getHasAfterPayParam,
  getLatestAccountBalance,
  getAccountBalanceParams,
  getConfirmPaymentOptions
});

 })(window);